<template>
  <div class="screen-index-page" v-screen-loading="isPageLoading">
    <div class="bsHeader">
      <div class="date">
        <small>{{ currentTime.date }}</small>
        <!-- <span>{{ currentTime.week }}</span> -->
        <span>{{ currentTime.time }}</span>
      </div>
      <div class="bsHeader-c">
        <div class="nav">
          <div
            class="nav-item"
            :class="{ 'is-active': $route.path == item.path }"
            v-for="item in menuList.slice(0, 2)"
            :key="item.path"
          >
            <span @click="clickMenuItem(item.path)">{{ item.title }}</span>
          </div>
        </div>
        <h5 :style="{ '--top-title-bg': `url(${topTitleBg})` }"></h5>
        <div class="nav">
          <div
            class="nav-item"
            :class="{ 'is-active': $route.path == item.path }"
            v-for="item in menuList.slice(2, 4)"
            :key="item.path"
          >
            <span @click="clickMenuItem(item.path)">{{ item.title }}</span>
          </div>
        </div>
      </div>
      <div class="right-go-back-button" @click="$router.push('/index')"></div>
    </div>
    <router-view ref="sonPageEl" :screenWidth="screenWidth"></router-view>
    <div class="bsFooter"></div>
  </div>
</template>

<script>
import "../../plugins/directive.js";
import dayjs from "dayjs";
import global from "@/mixins/global.js";
export default {
  name: "screenIndexPage",
  mixins: [global],
  provide: function () {
    return {
      $pageLoading: this.pageLoading,
    };
  },
  data() {
    return {
      currentTime: {
        time: "00:00:00",
        week: "星期一",
        date: "--.--.--",
      },
      currTimer: null,
      timer: false,
      screenWidth: 0,
      throttleTimer: null,
      isPageLoading: false,
      topTitleBg: require("@/assets/img/largeScreen/largeScreenTitle.png"),
    };
  },
  watch: {
    screenWidth(val) {
      if (!this.timer) {
        this.screenWidth = val;
        this.timer = true;
        setTimeout(() => {
          this.timer = false;
        }, 400);
      }
    },
  },
  computed: {
    menuList() {
      let names = (this.$store.state.permissions || [])
        .filter((t) => t.type == 1)
        .map((v) => v.name);
      let baseP = "/largeScreen/screenPage";
      return [
        {
          title: this.$l("信息概览"),
          path: baseP + "/indexBigScreen",
          name: "indexBigScreen",
        },
        {
          title: this.$l("运行诊断"),
          path: baseP + "/deviceBigScreen",
          name: "deviceBigScreen",
        },
        {
          title: this.$l("风险监测"),
          path: baseP + "/riskMonitor",
          name: "riskMonitor",
        },
        {
          title: this.$l("设备巡视"),
          path: baseP + "/deviceMonitor",
          name: "deviceMonitor",
        },
        // {
        //   title: this.$l("体检分析"),
        //   path: baseP + "/analysisBigScreen",
        //   name: "analysisBigScreen",
        // },
        // { title: this.$l("体检分析"), path: baseP + "/1" },
      ].filter(
        (t) => this.$store.state.user.roleType == 1 || names.includes(t.name),
      );
    },
  },
  created() {
    const userJson = localStorage.getItem("user");
    const permissionJson = localStorage.getItem("permissions");
    if (!userJson) {
      this.$router.push({
        path: "login",
      });
    }
    this.$store.state.user = JSON.parse(userJson);
    if (
      this.$store.state.user.roleType != 1 &&
      (!permissionJson || JSON.parse(permissionJson).length == 0)
    ) {
      this.$router.push({
        path: "login",
      });
    }
    this.$store.state.permissions = JSON.parse(permissionJson);
    const indexJson = localStorage.getItem("indexPermissions");
    if (indexJson) {
      this.$store.state.indexPermissions = JSON.parse(indexJson);
    }
    const fieldJson = localStorage.getItem("fieldPermissions");
    if (fieldJson) {
      this.$store.state.fieldPermissions = JSON.parse(fieldJson);
    }
    this.$store.state.siderConfig.isHide = true; //隐藏左边菜单
    this.$store.state.isHiddenHeader = true; //隐藏头部
    this.$store.state.indexLiftStatusTimer = null;
    this.$store.state.indexDeviceStatusTimer = null;
    this.$store.state.indexRealTimer = null;
    this.$store.state.checkIndexRealTimer = null;
    this.funResize();
    this.setCurrentTime();
  },
  mounted() {
    // console.log(this.$refs.sonPageEl);
    this.getSpecialUser();
    window.addEventListener("resize", this.funResize, false);
  },
  methods: {
    getSpecialUser(){
       const user = this.getSpecialUserInfo();
       if(user) {
          this.topTitleBg = user.titleBgUrl;
       }
       return user;
    },
    setCurrentTime() {
      let weekName = "星期";
      let weeks = ["一", "二", "三", "四", "五", "六", "天"];
      this.currTimer = setInterval(() => {
        this.currentTime.date = dayjs().format("YYYY年MM月DD日");
        const index = dayjs().$W == 0 ? weeks.length - 1 : dayjs().$W - 1;
        this.currentTime.week = this.$l(weekName + weeks[index]);
        this.currentTime.time = dayjs().format("HH:mm:ss");
      }, 1000);
    },
    funResize() {
      window.screenWidth =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
      const that = this;
      that.screenWidth = window.screenWidth;
      let htmlobj = document.getElementsByTagName("html")[0];
      htmlobj.style.fontSize = (that.screenWidth / 1920) * 16 + "px";
      clearTimeout(this.throttleTimer);
      this.throttleTimer = setTimeout(() => {
        if (this.$refs.sonPageEl && this.$refs.sonPageEl.$browserWidthChange) {
          this.$refs.sonPageEl.$browserWidthChange();
        }
      }, 500);
    },
    clickMenuItem(path) {
      if (this.$route.path == path) return;
      if (path.includes("1") || path.includes("2")) {
        return this.$message(this.$l("即将上线"));
      }
      this.$router.push(path);
    },
    pageLoading(loading) {
      this.isPageLoading = loading;
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.funResize, false);
    window.clearInterval(this.currTimer);
    this.$store.state.siderConfig.isHide = false;
    this.$store.state.isHiddenHeader = false;
  },
};
</script>

<style lang="scss" scoped>
.screen-index-page {
  --bs-color-text-primary: #ecf0ff;
  --bs-color-text-regular: #ccd9ff;
  --bs-color-text-secondary: #a5aee8;
  --bs-color-text-placeholder: #5f76bc;
  --bs-color-primary: #3863e9;
  --bs-color-em: #8ae4ef;
  --bs-color-warning: #ffce7f;
  --bs-color-info: #87b9ff;
  --bs-color-danger: #fb5c5d;
  --bs-color-success: #2ce3b5;
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  user-select: none;
  // font-family: AlibabaPuHuiTi;
  // min-width: 1380px;
  // min-width: 755px;
  background: url("../../assets/img/largeScreen/bg.jpg") no-repeat center;
  background-size: cover;
}

.bsHeader {
  height: vh(100);
  // min-height: 70px;
  position: relative;
  display: flex;
  justify-content: center;
  &::before {
    content: "";
    position: absolute;
    z-index: 0;
    width: 100%;
    top: 0;
    height: 155%;
    background: url("../../assets/img/largeScreen/header_bg.png") no-repeat top
      center;
    background-size: 100% 100%;
  }
  > * {
    position: relative;
    z-index: 2;
  }
  &-c {
    width: 90%;
    display: flex;
    align-items: center;
    justify-content: space-around;
  }
  h5 {
    height: vh(44);
    margin-top: vh(-8);
    width: 28vw;
    background: var(--top-title-bg) no-repeat center;
    background-size: auto 100%;
  }
}
.bsFooter {
  height: vh(14);
  background: url("../../assets/img/largeScreen/footer_bg.png") no-repeat center;
  background-size: 100% 100%;
}
.nav {
  display: flex;
  margin-top: vh(36);
  gap: vw(10);
  min-width: 22.08333vw;
  justify-content: center;
  &-item {
    width: vw(207);
    height: vw(67);
    line-height: vw(56);
    text-align: center;
    color: #ccdeff;
    font-size: vw(20);
    font-weight: 500;
    background: url("../../assets/img/largeScreen/menuItem_bg.png") no-repeat
      center;
    background-size: 100% 100%;
    cursor: pointer;
    transition: all 0.2s ease;
    &:hover {
      color: #fff;
    }
    &.is-active {
      background: url("../../assets/img/largeScreen/menuItem_bg_on.png")
        no-repeat center;
      background-size: 100% 100%;
      font-weight: bold;
      color: #fff;
    }
  }
}
.date {
  position: absolute;
  left: vw(30);
  top: vh(40);
  color: var(--bs-color-text-secondary);
  font-family: DINPro;
  line-height: 1.8;
  small {
    font-size: vw(12);
    display: block;
  }
  span {
    font-size: vw(16);
  }
}
.right-go-back-button {
  position: absolute;
  right: vw(32);
  top: vh(42);
  height: 100%;
  width: vw(40);
  height: vw(40);
  box-sizing: border-box;
  z-index: 998;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-image: linear-gradient(
    180deg,
    rgba(9, 34, 88, 0) 0%,
    #34367f 100%
  );
  border-radius: 50em;
  box-shadow: inset 0 0 0 1px rgba(204, 217, 255, 0.12),
    0 4px 12px 0 rgba(56, 99, 233, 0.46),
    inset 0 0 7px 0 rgba(132, 162, 255, 0.4);
  transition: all 0.2s ease;
  cursor: pointer;
  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: url("../../assets/img/largeScreen/logout_icon.png") no-repeat
      center;
    background-size: 100% 100%;
  }
  &:hover {
    box-shadow: inset 0 0 0 1px rgba(204, 217, 255, 0.5),
      0 4px 12px 0 rgba(56, 99, 233, 0.46),
      inset 0 0 7px 0 rgba(132, 162, 255, 0.4);
  }
}
::v-deep,
/deep/ {
  .bsPanel {
    // &-h {
    //   height: vh(48);
    //   background: url("../../assets/img/largeScreen/panel_h.png") no-repeat left
    //     center;
    //   background-size: 100% 100%;
    // }
    display: flex;
    flex-direction: column;
    &-c {
      flex: 1;
      min-height: 10px;
      padding: vw(28);
      background: url("../../assets/img/largeScreen/panel_c.png") no-repeat top
        center;
      background-size: 100% 100%;
      display: flex;
      flex-direction: column;
    }
  }
  .bsTitle {
    height: vh(48);
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: url("../../assets/img/largeScreen/panel_h.png") no-repeat left
      center;
    background-size: 100% 100%;
    font-size: vw(16);
    padding: 0 1.6em 0 2.5em;
    h4 {
      position: relative;
      font-weight: bold;
      // margin-left: 2em;
      font-size: 1.12em;
      line-height: 1;
      color: transparent;
      text-shadow: 0 0.2em 0.4em rgba(0, 0, 0, 0.45);
      &::after {
        content: attr(text);
        position: absolute;
        left: 0;
        z-index: 9;
        color: #ffffff;
        text-align: center;
        background-image: linear-gradient(to top, #aec5fe, #ffffff);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        text-shadow: none;
      }
    }
    &-extra {
      color: var(--bs-color-text-secondary);
      font-size: vw(14);
      font-weight: 500;
      em {
        font-style: initial;
        font-weight: 500;
        color: var(--bs-color-text-primary);
      }
    }
    &--small {
      background: url("../../assets/img/largeScreen/panel_h_s.png") no-repeat
        left center;
      background-size: 100% 100%;
    }
  }
  .bsColname {
    height: vh(36);
    line-height: vh(26);
    margin-left: 0.5em;
    padding-left: 2.2em;
    display: flex;
    background: url("../../assets/img/largeScreen/subTitle_bg.png") no-repeat
      left center;
    background-size: auto 100%;
    font-size: vw(16);
    font-weight: bold;
    color: var(--bs-color-text-regular);
    text-shadow: 0 0 0.5em rgba(56, 99, 233, 0.5);
  }
}
::v-deep,
/deep/ {
  .el-button {
    border-radius: 4px;
    &.is-circle {
      border-radius: 50em;
    }
  }
  .el-button--default {
    color: var(--bs-color-text-regular);
    background-color: transparent;
    border-color: #35436e;
  }
  .el-button--primary {
    color: #ffffff;
    background-color: var(--bs-color-primary);
    border-color: var(--bs-color-primary);
  }
  .el-button--primary.is-disabled,
  .el-button--primary.is-disabled:hover,
  .el-button--primary.is-disabled:focus,
  .el-button--primary.is-disabled:active {
    background-color: rgb(135, 168, 246);
    border-color: rgb(135, 168, 246);
  }

  .el-button--em {
    &[light] {
      background: rgba(#8ae4ef, 0.1);
      border-color: rgba(#8ae4ef, 0.1);
      color: #8ae4ef;
    }
  }
  //form
  .el-input__inner {
    background: rgba(0, 6, 51, 0.6);
    background-image: linear-gradient(
      180deg,
      rgba(56, 121, 255, 0) 0%,
      rgba(56, 100, 255, 0.1) 100%
    );
    border: 1px solid #2d3a78;
    border-radius: 4px;
    color: var(--bs-color-text-regular);
  }
  .el-input__inner:focus {
    border-color: var(--bs-color-primary);
  }
  .el-input__inner::placeholder {
    color: var(--bs-color-text-placeholder);
  }
  .el-select .el-input .el-select__caret {
    color: #8797ff;
  }
  .el-select .el-input.is-focus .el-input__inner {
    border-color: var(--bs-color-primary);
  }
  .el-select-dropdown {
    background-color: rgba(13, 25, 66, 1);
    border-color: rgba(13, 25, 66, 1);
    .popper__arrow {
      &::after {
        border-bottom-color: rgba(13, 25, 66, 1);
      }
      border-bottom-color: rgba(13, 25, 66, 1);
    }
    .hover {
      background-color: rgba(56, 99, 233, 50%);
    }
    span {
      color: #fff;
    }
  }
  .el-checkbox__inner {
    background-color: rgba(56, 99, 233, 0.25);
    border-color: rgba(56, 99, 233, 0.25);
  }
  .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: var(--bs-color-primary);
  }
  .el-checkbox__input.is-indeterminate .el-checkbox__inner,
  .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: var(--bs-color-primary);
    border-color: var(--bs-color-primary);
  }

  //table
  .el-table {
    background: none;
    color: var(--bs-color-text-primary);
  }
  .el-table::before,
  .el-table--group::after,
  .el-table--border::after,
  .el-table__fixed::before,
  .el-table__fixed-right::before {
    background-color: #2d3a78;
  }
  .el-table__body-wrapper {
    @extend %scroll-bs;
  }
  .el-table__empty-text {
    color: var(--bs-color-text-secondary);
  }
  .el-table thead {
    color: #acbbf6;
    font-weight: 500;
  }
  .el-table th {
    background: linear-gradient(
      0deg,
      #3e50b8 0%,
      rgba(46, 61, 196, 0.3) 50%,
      rgba(42, 58, 193, 0.25) 100%
    );
  }
  .el-table .sort-caret.ascending {
    border-bottom-color: #355ca8;
  }
  .el-table .sort-caret.descending {
    border-top-color: #355ca8;
  }
  .el-table .ascending .sort-caret.ascending {
    border-bottom-color: var(--bs-color-em);
  }
  .el-table .descending .sort-caret.descending {
    border-top-color: var(--bs-color-em);
  }
  .el-table tr {
    background: rgba(#0a103d, 0.5);
  }
  .el-table--striped .el-table__body tr.el-table__row--striped td {
    background: rgba(#283f83, 0.35);
  }
  .el-table__body tr.hover-row > td,
  .el-table__body tr.hover-row.current-row > td,
  .el-table__body tr.hover-row.el-table__row--striped > td,
  .el-table__body tr.hover-row.el-table__row--striped.current-row > td {
    background: rgba(#283f83, 0.8);
  }
  .el-table__body tr.current-row > td {
    background: #313f98 !important;
  }
  .el-table th.is-leaf,
  .el-table td {
    border-bottom: none;
  }

  //pagination
  .el-pagination {
    color: var(--bs-color-text-secondary);
  }

  .el-pagination button:disabled {
    background: none;
    color: var(--bs-color-text-placeholder);
  }
  .el-pagination .btn-prev,
  .el-pagination .btn-next {
    background: none;
    color: var(--bs-color-text-secondary);
  }
  .el-pager li {
    background: none;
    border-radius: 4px;
  }
  .el-pager li.active {
    background: rgba(#3863e9, 0.8);
  }
  .el-pager li.btn-quicknext,
  .el-pager li.btn-quickprev {
    color: var(--bs-color-text-secondary);
  }
  .el-pagination__total,
  .el-pagination__jump {
    color: var(--bs-color-text-regular);
  }
}
</style>
